import { ROOT_MODULE_ACTION } from "../enums/module-name-enums";

interface Module {
  name: string;
  actionList: { actionName: string; hasPermission: boolean }[];
  childMenuList: Module[];
  hasPermission: boolean;
}

const isModuleAndActionAvailable = async (
  moduleName: string,
  actionName: string,
  modules: Module[]
): Promise<boolean> => {
  for (const module of modules) {
    if (module.name === moduleName) {
      if (actionName === ROOT_MODULE_ACTION) {
        return module.hasPermission;
      }

      if (module?.actionList && module?.actionList?.length > 0) {
        for (const action of module.actionList) {
          if (
            action.actionName.toLocaleLowerCase() ==
            actionName.toLocaleLowerCase()
          ) {
            return action.hasPermission;
          }
        }
      }
    }

    if (module?.childMenuList && module?.childMenuList?.length > 0) {
      const isActionAvailableInChildren = await isModuleAndActionAvailable(
        moduleName,
        actionName,
        module.childMenuList
      );

      if (isActionAvailableInChildren) {
        return true;
      }
    }
  }
  return false;
};

export default isModuleAndActionAvailable;
